export default __webpack_public_path__ + "static/searching-for-buyer-fabric-view-22159ac6d65cfe8379b25470d279a109.png";